import { render, staticRenderFns } from "./BoardCardsYard.vue?vue&type=template&id=10fc53f4&"
import script from "./BoardCardsYard.vue?vue&type=script&lang=js&"
export * from "./BoardCardsYard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports